<template>
  <div id="maphome">
    <div id="home-1">
      <div class="text">地图列表</div>
      <Tooltip content="Leaflet 类库包" placement="right">
        <div class="maplist" @click="toMapUseView">地图浏览</div>
      </Tooltip>
      <Tooltip content="Tangram 插件" placement="right">
        <div class="maplist" @click="toMapUseTangram">Tangram试验</div>
      </Tooltip>
      <Tooltip content="OpenLayers 类库包" placement="right">
        <div class="maplist" @click="toMapUseOlayer">OpenLayers试验</div>
      </Tooltip>
    </div>
    <div id="map"></div>
  </div>
</template>

<script>
  export default {
    name: 'mapHome',
    data() {
      return {

      }
    },
    computed: {},
    mounted() {
      this.init();
    },
    watch: {},
    methods: {
      // 初始化
      init() {
        this.$Notice.destroy();
        var map = L.map('map', {
          scrollWheelZoom: false,
          zoomControl: false,
          attributionControl: false,
        });
        var layer = Tangram.leafletLayer({
          scene: '../../../static/lib/scene.yaml',
        });
        layer.addTo(map);
        map.setView([39.916042, 116.390694], 13);
      },
      toMapUseView() {
        this.$router.push({
          name: "mapUseView",
        });
      },
      toMapUseTangram() {
        this.$router.push({
          name: "mapUseTangram",
        });
      },
      toMapUseOlayer() {
        this.$router.push({
          name: "mapUseOpenlayer",
        });
      },
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #maphome {
    overflow-y: hidden;
  }

  #home-1 {
    margin: 0 auto;
    margin-top: 15%;
    font-size: 16px;
    z-index: 12;
    width: 200px;
    background: rgba(15, 15, 15, 0.65);
    padding: 20px;
  }

  #map {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    z-index: -1;
    cursor: default;
  }

  .text {
    text-align: center;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.647058823529412);
    font-family: '微軟正黑體 Bold', '微軟正黑體';
    font-weight: 700;
    font-style: normal;
    color: white;
    z-index: 10;
    margin: 10px;
  }

  .maplist {
    color: #2d8cf0;
    cursor: pointer;
    font-weight: 700;
    font-style: normal;
  }

</style>



// WEBPACK FOOTER //
// mapHome.vue?3f9f4b94